import React from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { T } from '@sm/intl';

import COPY from '~app/pages/Pricing/copy';

import useHeadingStyles from './useStyles';

type HeadingProps = {
  children?: string;
};

export default function MainHeading({ children }: HeadingProps): React.ReactElement {
  const { Heading } = useHeadingStyles();

  return (
    <Box className={Heading}>
      <Typography component="h1" variant="hero2" data-testid="MainHeading">
        {children ?? <T desc={COPY.MAIN_HEADING} />}
      </Typography>
    </Box>
  );
}
